import { Link } from "react-router-dom";
import "../../App.css";
import CategoryGrid from "../CategoryGrid";
import Footer from "../Footer";
import Reveal from "../Reveal";
import Seo from "../Seo";
import "./ProductenIndex.css";

function ProductenIndex() {
	return (
		<>
			<Seo
				title="Onze collectie"
				description="Bekijk onze volledige verhuurcollectie: LED cijfers & letters, verlichting, ballondecoratie, photobooth en LED-dansvloer."
				path="/producten"
			/>
			<section className="producten-index-hero">
				<span className="producten-index-eyebrow">DE COLLECTIE</span>
				<h1 className="producten-index-title">Onze collectie</h1>
				<p className="producten-index-intro">
					Van lichtgevende cijfers en sfeervolle LED-bars tot ballondecoratie
					en photobooth — alles wat u nodig heeft om uw evenement onvergetelijk
					te maken.
				</p>
			</section>

			<Reveal className="reveal--stagger">
				<CategoryGrid />
			</Reveal>

			<Reveal as="section" className="producten-index-cta">
				<div className="producten-index-cta-inner">
					<span className="producten-index-cta-eyebrow">AANVRAAG OP MAAT</span>
					<h2 className="producten-index-cta-title">Niet zeker wat past?</h2>
					<p className="producten-index-cta-text">
						Stel samen met ons een passend pakket samen voor uw feest of
						evenement.
					</p>
					<Link
						to="/aanvraag"
						className="btn btn--primary btn--on-dark btn--lg">
						Stel uw aanvraag samen
					</Link>
				</div>
			</Reveal>

			<Footer />
		</>
	);
}

export default ProductenIndex;
